/**
 * Shared appearance for Clerk-hosted UI so it matches the Optimiciti brand.
 *
 * Pass to any Clerk component's `appearance` prop (e.g. <PricingTable appearance={clerkAppearance} />).
 * It can also be passed to <ClerkProvider appearance={...}> to theme every Clerk
 * surface (SignIn, UserButton, checkout drawer) in one place — we scope it to the
 * pricing table for now to keep the blast radius small.
 *
 * `colorPrimary` is the main lever (buttons, the highlighted plan, links). The
 * rest nudge Clerk toward the site's radius/typography; tweak freely.
 */
import colors from "assets/theme/colors.js";

const clerkAppearance = {
  variables: {
    colorPrimary: colors.primary.main, // #017C76
    colorText: "#525f7f",
    // Was #8898aa, which is 2.95:1 — Clerk uses this for plan descriptions and
    // feature lists, i.e. the text someone reads before entering card details.
    // #6b7280 keeps a step below colorText and clears AA at 4.8:1.
    colorTextSecondary: "#6b7280",
    borderRadius: "0.75rem",
    fontFamily: "inherit", // use the site's font stack
    fontSize: "0.9rem",
  },
  elements: {
    // Match the soft card treatment used elsewhere on the site.
    card: { boxShadow: "0 4px 6px rgba(0, 0, 0, 0.02)" },
  },
};

export default clerkAppearance;
